import axios from 'axios'
import config from '../config'

export default {
    getProfile() {
        return axios.get(config.publicPath + 'profile');
    },
    getUsers(currentPage, perPage, username) {
        return axios.get(config.publicPath + 'users', {
            params: {_page: currentPage, itemsPerPage: perPage, username: username},
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status < 500;
            }
        });
    },
    getUserSelect() {
        return axios.get(config.publicPath + 'users', {
            params: {'groups[]': 'select', 'pagination': false},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    createUser(user) {
        return axios.post(config.publicPath + 'users', user,{
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getUser(id) {
        return axios.get(config.publicPath + 'users/' + id);
    },
    updateUser(id, user) {
        return axios.put(config.publicPath + 'users/' + id, user,{
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    deleteUser(id) {
        return axios.delete(config.publicPath + 'users/' + id);
    }
}
